import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { transition } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import arrowLeft from "../../../assets/images/icons/arrow-left.svg";
import arrowRight from "../../../assets/images/icons/arrow-right.svg";

export const ArrowContainer = styled.div`
  opacity: 1;
  z-index: 20;
  height: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: ${(props) => (props.floatRight ? "auto" : "")};
  margin-right: ${(props) => (props.floatRight ? "0" : "")};
  margin-bottom: ${(props) => (props.floatRight ? "15px" : "")};
  ${breakpoints.smDown} {
    display: none;
  }
`;

export const StyledImage = styled.img`
  width: 20px;
  display: inline-block;
  vertical-align: middle;
  object-fit: cover;
  height: 12px;
  &:not(:last-child) {
    margin-right: 15px;
  }
  &:hover {
    transition: ${transition.baseTransition};
    transform: scale(0.9);
  }
  cursor: pointer;
`;

const ScrollLeftRightArrows = ({ handleLeftArrowClickScroll, handleRightArrowClickScroll }) => (
  <ArrowContainer>
    <StyledImage src={arrowLeft} onClick={() => handleLeftArrowClickScroll()} />
    <StyledImage src={arrowRight} onClick={() => handleRightArrowClickScroll()} />
  </ArrowContainer>
);

ScrollLeftRightArrows.propTypes = {
  handleRightArrowClickScroll: PropTypes.func.isRequired,
  handleLeftArrowClickScroll: PropTypes.func.isRequired,
};

export default ScrollLeftRightArrows;
